import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/bff-communication.service';
import { ErreurSpa } from '../../core/modeles/erreur-spa.modele';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TracingSpaApiService {
  private readonly urlApi = '/api/v1/tracingSpa';

  constructor(private readonly _bffCommunicationService: BffCommunicationService) {}

  postLogErreurSpa(erreurSpa: ErreurSpa): Promise<void | Object> {
    return this._bffCommunicationService
      .postJSONBFF(`${this.urlApi}/logErreurSpa`, erreurSpa)
      .toPromise()
      .catch(err => {
        console.log('Could not log error:', err);
      });
  }

  postLogPageErreurSpa(httpError: HttpErrorResponse): Promise<void | Object> {
    return this._bffCommunicationService
      .postJSONBFF(`${this.urlApi}/logPageErreurSpa`, httpError)
      .toPromise()
      .catch(err => {
        console.log('Could not log error page:', err);
      });
  }
}
